import _toConsumableArray from "/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { parseUrl } from './transform';
import { EnvType, Region, Language, SaasId, Platform, LanguageForRegion, ShopeeRegionSuffix, InsuranceRegionSuffix } from './types';
export function toURL(platformInfo) {
  var _platformInfo$saasId = platformInfo.saasId,
    saasId = _platformInfo$saasId === void 0 ? SaasId.Shopee : _platformInfo$saasId,
    _platformInfo$platfor = platformInfo.platform,
    platform = _platformInfo$platfor === void 0 ? Platform.Inhouse : _platformInfo$platfor;
  var suffix = domainSuffix(platformInfo);
  switch (saasId) {
    case SaasId.ShopeePay:
    case SaasId.Foody:
      return platform === Platform.Help ? "https://".concat(platform, ".cs").concat(suffix) : "https://".concat(platform).concat(suffix);
    case SaasId.SeaBankID:
    case SaasId.MaribankSgOrPh:
      return platform === Platform.Help ? "https://cs".concat(suffix) : "https://cs-inhouse".concat(suffix);
    case SaasId.OpenPlatform:
      return "https://open-platform.cs".concat(suffix);
    case SaasId.XXTenant:
      return "https://cs".concat(suffix);
    default:
      return "https://".concat(platform).concat(suffix);
  }
}
export function domainSuffix(platformInfo) {
  var _platformInfo$env = platformInfo.env,
    env = _platformInfo$env === void 0 ? EnvType.LIVE : _platformInfo$env,
    _platformInfo$region = platformInfo.region,
    region = _platformInfo$region === void 0 ? Region.SG : _platformInfo$region,
    _platformInfo$saasId2 = platformInfo.saasId,
    saasId = _platformInfo$saasId2 === void 0 ? SaasId.Shopee : _platformInfo$saasId2,
    _platformInfo$platfor2 = platformInfo.platform,
    platform = _platformInfo$platfor2 === void 0 ? Platform.Inhouse : _platformInfo$platfor2;
  var envSuffix = env === EnvType.LIVE ? '' : ".".concat(env);
  switch (saasId) {
    case SaasId.Insurance:
      return "".concat(envSuffix, ".seainsure.").concat(InsuranceRegionSuffix[region]);
    case SaasId.ShopeePay:
      return "".concat(envSuffix, ".shopeepay.").concat(ShopeeRegionSuffix[region]);
    case SaasId.OpenPlatform:
      return "".concat(envSuffix, ".shopee.com");
    case SaasId.ShopeeCredit:
      return "".concat(envSuffix, ".scredit.in.th");
    case SaasId.Foody:
      return "".concat(envSuffix, ".shopeefood.vn");
    case SaasId.AMP:
      return ".gi".concat(envSuffix, ".seainsure.co.id");
    case SaasId.SeaBankID:
      return platform === Platform.Help ? "".concat(envSuffix, ".seabank.co.id") : ".id".concat(envSuffix, ".seabank.io");
    case SaasId.MaribankSgOrPh:
      if (region === Region.SG) {
        return platform === Platform.Help ? "".concat(envSuffix, ".maribank.com.sg") : "".concat(envSuffix, ".sg.maribank.io");
      }
      return platform === Platform.Help ? "".concat(envSuffix, ".seabank.ph") : "".concat(envSuffix, ".ph.seabank.io");
    case SaasId.CMF:
      return "".concat(envSuffix, ".cmf.co.id");
    case SaasId.BCL:
      return "".concat(envSuffix, ".lenteradana.co.id");
    case SaasId.XXTenant:
      return "".concat(envSuffix, ".shopee.systems");
    case SaasId.Shopee:
    default:
      return "".concat(envSuffix, ".shopee.").concat(ShopeeRegionSuffix[region]);
  }
}
var DEFAULT_PLATFORM_INFO = Object.freeze({
  env: EnvType.LIVE,
  region: Region.SG,
  language: Language.SG,
  saasId: ''
});
function normalizeURL(url) {
  if (!url) {
    return null;
  }
  // Add 'https://' if the URL does not start with 'http://' or 'https://'
  if (!/^https?:\/\//i.test(url)) {
    url = 'https://' + url;
  }
  return url;
}
export function parse(platformUrl) {
  var _a;
  if (typeof window === 'undefined' && !platformUrl) {
    // 非浏览器环境下，必须传入platformUrl
    throw new Error('Non-browser environment must be passed in platformUrl');
  }
  try {
    var _parseUrl = parseUrl((_a = normalizeURL(platformUrl)) !== null && _a !== void 0 ? _a : location.origin),
      _parseUrl$hostname = _parseUrl.hostname,
      hostname = _parseUrl$hostname === void 0 ? '' : _parseUrl$hostname;
    /* c8 ignore start */
    if (!hostname) {
      return DEFAULT_PLATFORM_INFO;
    }
    /* c8 ignore end */
    if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname.startsWith('192.168')) {
      return _objectSpread(_objectSpread({}, DEFAULT_PLATFORM_INFO), {}, {
        env: EnvType.DEV
      });
    }
    var sequence = hostname.split('.');
    var env = getEnv(sequence);
    var region = getRegion(sequence);
    var language = LanguageForRegion[region];
    var saasId = getSaasID(sequence);
    return {
      env: env,
      region: region,
      language: language,
      saasId: saasId
    };
  } catch (e) {
    return DEFAULT_PLATFORM_INFO;
  }
}
function getEnv(sequence) {
  var envs = Object.values(EnvType);
  var env = sequence.find(function (name) {
    return envs.includes(name);
  }) || EnvType.LIVE;
  return env;
}
function getRegion(sequence) {
  var checkSequence = _toConsumableArray(sequence).reverse();
  if (checkSequence[0] === 'systems') {
    return Region.XX;
  }
  if (checkSequence.includes('open-platform')) {
    return Region.CN;
  }
  var regions = Object.values(Region);
  var region = checkSequence.find(function (name) {
    return regions.includes(name);
  });
  return region || Region.SG;
}
function getSaasID(sequence) {
  var hostname = sequence.join('.');
  if (hostname.includes('.shopeepay.')) {
    return SaasId.ShopeePay;
  }
  if (hostname.includes('.scredit.')) {
    return SaasId.ShopeeCredit;
  }
  if (hostname.includes('.shopeefood.')) {
    return SaasId.Foody;
  }
  if (['.gi.', '.seainsure.'].every(function (str) {
    return hostname.includes(str);
  })) {
    return SaasId.AMP;
  }
  if (hostname.includes('id.seabank')) {
    return SaasId.SeaBankID;
  }
  if (hostname.includes('.cmf.')) {
    return SaasId.CMF;
  }
  if (hostname.includes('.lenteradana.') || hostname.includes('.ldn.')) {
    return SaasId.BCL;
  }
  if (hostname.includes('shopee.systems')) {
    return SaasId.XXTenant;
  }
  if (hostname.includes('sg.maribank')) {
    return SaasId.MaribankSgOrPh;
  }
  if (hostname.includes('ph.seabank')) {
    return SaasId.MaribankSgOrPh;
  }
  if (hostname.includes('.seainsure.')) {
    return SaasId.Insurance;
  }
  if (hostname.includes('open-platform')) {
    return SaasId.OpenPlatform;
  }
  // 优先判断其他好判断的租户，shopee放最后
  if (hostname.includes('.shopee.')) {
    return SaasId.Shopee;
  }
  return '';
}